import { render, staticRenderFns } from "./PrescriptionStatus.vue?vue&type=template&id=4dcf5a3d&scoped=true&"
import script from "./PrescriptionStatus.vue?vue&type=script&lang=js&"
export * from "./PrescriptionStatus.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionStatus.vue?vue&type=style&index=0&id=4dcf5a3d&prod&scoped=true&lang=css&"
import style1 from "./PrescriptionStatus.vue?vue&type=style&index=1&id=4dcf5a3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf5a3d",
  null
  
)

export default component.exports